import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { FormHelperText } from '@mui/material';
import { UploadAvatar } from '../upload';

const URL = process.env.REACT_APP_BASE_FILES_URL;

export function AdapterUploadAvatar({ name, control, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error, invalid } }) => {
        const checkError = invalid && !field.value;
        const file = field.value !== '' && typeof field.value !== 'object' ? `${URL}/${field.value}` : field.value;

        return (
          <div>
            <UploadAvatar error={checkError} {...rest} file={file} />
            {checkError && (
              <FormHelperText error sx={{ px: 2, textAlign: 'center' }} data-testid="error-message">
                {error.message}
              </FormHelperText>
            )}
          </div>
        );
      }}
    />
  );
}

AdapterUploadAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
};
